// How often the My Meters and Manage Meter pages re-read the user's meters.
export const METER_REFRESH_INTERVAL_MS = 60000;

export const emailRegEx = "/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/";

export const colorArray = [
  
    
  {r: 31, g: 119, b: 180}, // muted blue
  {r: 255, g: 127, b: 14}, // safety orange
  {r: 44, g: 160, b: 44}, // cooked asparagus green
  {r: 214, g: 39, b: 40},  // brick red
    {r: 148, g: 103, b: 189}, // purple
    {r: 140, g: 86, b: 75}, // brown
    {r: 227, g: 119, b: 194}, // pink
    {r: 127, g: 127, b: 127}, // gray
    {r: 188, g: 189, b: 34}, // yellow-green
    {r: 23, g: 190, b: 207} // cyan
];
